var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 68.36,
    cy: -269.2,
    r: 342.33,
    gradientTransform: "matrix(1.98 0 0 1.98 104.42 463.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cce3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#b0d9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#7bc6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4fb6dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#2da9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#14a0d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#059bd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0099d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#006e98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0e3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152757"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 2.7C116.16 2.7 3 115.89 3 255.79 3 396.12 116.16 509.3 256 509.3s253-113.17 253-253.5C509 115.89 395.77 2.7 256 2.7zm-70.73 319.78c-7.16-.41-12.1 1.4-16.69 7-12.23 15.31-25.24 29.79-37.75 44.41-7 4.18-5.15-1.94-5.15-4.73-.14-16.42-.49-32.29.28-48.44.21-8.5-2.16-14.2-10.29-17.68-13-6.13-24.05-16-33.23-27.16-25.93-31.73-24.26-72.25 3.82-102.17 22.39-23.68 50.82-35.78 82.52-40.51 52.7-7.53 100.81 2.78 140.85 40.51 33 39.24 24.4 77 2.78 103-12.79 15.31-28.85 25.62-47 33.69-25.78 10.68-52.62 14.3-80.14 12.08zm222.6-4.59c-7.43 4.18-9.8 8.77-9.31 16.56.48 14.47 0 28.54 0 46.63-12.79-14.47-23.85-26.44-34.2-39.12-4.58-5.15-9-7.51-16.54-7-23.15 1.81-45.89-1.81-67.16-11.69-2.85-1.25-6.32-2-8.06-6.13 32.61-15.31 59.86-36.19 67.29-73.93 4.66-22.82-.56-44.26-15.51-63.05 15.92-5.57 31.78-2.24 47.41 1 31 7 56.52 22 72.51 50.81 10.36 38.16-.84 65.73-36.44 85.92z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258 4.68C118.13 4.68 5 117.87 5 257.77c0 140.33 113.13 253.5 253 253.5s253-113.17 253-253.5C511 117.87 397.75 4.68 258 4.68zm-70.76 319.78c-7.16-.41-12.1 1.4-16.69 7-12.23 15.31-25.24 29.79-37.75 44.41-7 4.18-5.15-1.94-5.15-4.73-.14-16.42-.49-32.29.28-48.44.21-8.5-2.16-14.2-10.29-17.68-13-6.13-24.05-16-33.23-27.16-25.93-31.73-24.26-72.25 3.82-102.17 22.39-23.68 50.82-35.78 82.52-40.51 52.7-7.53 100.81 2.78 140.85 40.51 33 39.24 24.4 77 2.78 103-12.79 15.31-28.85 25.62-47 33.69-25.78 10.68-52.62 14.3-80.14 12.08zm222.6-4.59c-7.43 4.18-9.8 8.77-9.31 16.56.48 14.47 0 28.54 0 46.63-12.79-14.47-23.85-26.44-34.2-39.12-4.58-5.15-9-7.51-16.54-7-23.15 1.81-45.89-1.81-67.16-11.69-2.85-1.25-6.32-2-8.06-6.13 32.61-15.31 59.86-36.19 67.29-73.93 4.66-22.82-.56-44.26-15.51-63.05 15.92-5.57 31.78-2.24 47.41 1 31 7 56.52 22 72.51 50.81 10.37 38.16-.84 65.73-36.43 85.92z",
    fill: "none",
    stroke: "#0f2975",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.05.73C114.18.73 1 113.91 1 253.81c0 140.33 113.18 253.5 253.05 253.5s253-113.17 253-253.5C507 113.91 393.8.73 254.05.73zM183.29 320.5c-7.16-.41-12.1 1.4-16.69 7-12.23 15.31-25.24 29.79-37.75 44.41-7 4.18-5.15-1.94-5.15-4.73-.14-16.42-.49-32.29.28-48.44.21-8.5-2.16-14.2-10.29-17.68-13-6.13-24.05-16-33.23-27.16-25.93-31.73-24.26-72.25 3.82-102.17 22.39-23.68 50.82-35.78 82.52-40.51 52.7-7.53 100.81 2.78 140.85 40.51 33 39.24 24.4 77 2.78 103-12.79 15.31-28.85 25.62-47 33.69-25.78 10.68-52.62 14.31-80.14 12.08zm222.6-4.59c-7.43 4.18-9.8 8.77-9.31 16.56.48 14.47 0 28.54 0 46.63-12.79-14.47-23.85-26.44-34.2-39.12-4.58-5.15-9-7.51-16.54-7-23.15 1.81-45.89-1.81-67.16-11.69-2.85-1.25-6.32-2-8.06-6.13 32.61-15.31 59.86-36.19 67.29-73.93 4.66-22.82-.56-44.26-15.51-63.05 15.92-5.57 31.78-2.24 47.41 1 31 7 56.52 22 72.51 50.81 10.37 38.17-.84 65.74-36.43 85.92z",
    fill: "none",
    stroke: "#cad8e9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 2.7C116.16 2.7 3 115.89 3 255.79 3 396.12 116.16 509.3 256 509.3s253-113.17 253-253.5C509 115.89 395.77 2.7 256 2.7zm-70.73 319.78c-7.16-.41-12.1 1.4-16.69 7-12.23 15.31-25.24 29.79-37.75 44.41-7 4.18-5.15-1.94-5.15-4.73-.14-16.42-.49-32.29.28-48.44.21-8.5-2.16-14.2-10.29-17.68-13-6.13-24.05-16-33.23-27.16-25.93-31.73-24.26-72.25 3.82-102.17 22.39-23.68 50.82-35.78 82.52-40.51 52.7-7.53 100.81 2.78 140.85 40.51 33 39.24 24.4 77 2.78 103-12.79 15.31-28.85 25.62-47 33.69-25.78 10.68-52.62 14.3-80.14 12.08zm222.6-4.59c-7.43 4.18-9.8 8.77-9.31 16.56.48 14.47 0 28.54 0 46.63-12.79-14.47-23.85-26.44-34.2-39.12-4.58-5.15-9-7.51-16.54-7-23.15 1.81-45.89-1.81-67.16-11.69-2.85-1.25-6.32-2-8.06-6.13 32.61-15.31 59.86-36.19 67.29-73.93 4.66-22.82-.56-44.26-15.51-63.05 15.92-5.57 31.78-2.24 47.41 1 31 7 56.52 22 72.51 50.81 10.36 38.16-.84 65.73-36.44 85.92z",
    fill: "none",
    stroke: "#8daed4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat2);
export default __webpack_public_path__ + "static/media/chat2.bfce934d4f3ea74bbb6ff93ba7b05ea9.svg";
export { ForwardRef as ReactComponent };